import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";

export const CtaBanner = () => {
  const { language } = useLanguage();
  const t = translations.cta[language] || translations.cta.en;

  // Calculate date 6 months from now
  const futureDate = new Date();
  futureDate.setMonth(futureDate.getMonth() + 6);
  
  const localeMap = {
    en: 'en-US',
    hi: 'hi-IN',
    pa: 'pa-IN',
    fr: 'fr-FR'
  };
  
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = futureDate.toLocaleDateString(localeMap[language] || 'en-US', options);

  return (
    <section id="cta-banner">
      <div className="container">
        <div className="cta-content">
          <div className="cta-text">
            <span className="cta-label">{language === 'en' ? 'Ready to Start?' : language === 'hi' ? 'शुरू करने के लिए तैयार?' : language === 'pa' ? 'ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਤਿਆਰ?' : 'Prêt à Commencer?'}</span>
            <h2>{language === 'en' ? 'Launch Your MVP in 6 Months' : language === 'hi' ? '6 महीने में अपना MVP लॉन्च करें' : language === 'pa' ? '6 ਮਹੀਨਿਆਂ ਵਿੱਚ ਆਪਣਾ MVP ਲੌਂਚ ਕਰੋ' : 'Lancez Votre MVP en 6 Mois'}</h2>
            <p>
              {language === 'en' ? 'If you reach out today, your minimum viable product could be ready by' : 
               language === 'hi' ? 'यदि आप आज संपर्क करें, तो आपका MVP तैयार हो सकता है' : 
               language === 'pa' ? 'ਜੇ ਤੁਸੀਂ ਅੱਜ ਸੰਪਰਕ ਕਰੋ, ਤਾਂ ਤੁਹਾਡਾ MVP ਤਿਆਰ ਹੋ ਸਕਦਾ ਹੈ' : 
               "Si vous nous contactez aujourd'hui, votre MVP pourrait être prêt le"}{" "}
              <strong>{formattedDate}</strong>
            </p>
          </div>
          <div className="cta-stats">
            <div className="cta-stat">
              <span className="stat-value">6-12</span>
              <span className="stat-text">{language === 'en' ? 'Months to MVP' : language === 'hi' ? 'MVP के लिए महीने' : language === 'pa' ? 'MVP ਲਈ ਮਹੀਨੇ' : 'Mois pour MVP'}</span>
            </div>
            <div className="cta-stat">
              <span className="stat-value">24/7</span>
              <span className="stat-text">{language === 'en' ? 'Support' : language === 'hi' ? 'सहायता' : language === 'pa' ? 'ਸਹਾਇਤਾ' : 'Support'}</span>
            </div>
            <div className="cta-stat">
              <span className="stat-value">100%</span>
              <span className="stat-text">{language === 'en' ? 'Transparent' : language === 'hi' ? 'पारदर्शी' : language === 'pa' ? 'ਪਾਰਦਰਸ਼ੀ' : 'Transparent'}</span>
            </div>
          </div>
          <a href="#contact" className="btn btn-cta page-scroll">
            {t.button}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};
